<template>

  <div>
    <v-card class="ma-1" outlined>

      <v-card-title>
        Detalii
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 444px;  overflow-y: auto">
        <template v-if="!hotel.static.general.description.ro">
          <v-alert dark color="error">
            <v-row no-gutters align="center">
              <v-icon left>mdi-alert</v-icon>
              Descrierea hotelului nu esta completata.
            </v-row>
          </v-alert>
        </template>
        <template v-else>
          {{ hotel.static.general.description.ro }}
        </template>

      </v-card-text>

    </v-card>
    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary white--text" flat dark>
          <v-toolbar-title>Detalii</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="ma-0 pa-4">
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="hotel.name" label="Nume" outlined dense hide-details/>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="hotel.static.general.description.ro"
                label="Descriere"
                auto-grow
                outlined
                dense
                hide-details
                rows="10"
              />
            </v-col>
            <v-col cols="12">
              <v-select v-model="hotel.status" label="Status" :items="statuses" outlined dense hide-details/>
            </v-col>
            <v-col cols="12">
              <v-select v-model="hotel.group_ids" label="Grupuri" :items="groups" multiple outlined dense hide-details chips small-chips/>
            </v-col>
            <v-col cols="12" align="center">
              <v-rating v-model="hotel.static.general.classification.level"/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

  import config_repository from '@/repositories/config-repository'
  import group_repository from '@/repositories/group-repository'

  export default {
    props: {
      hotel: null
    },

    data: () => ({
      dialog: false,
      statuses: null,
      groups: null
    }),

    created() {
      config_repository.getHotelStatuses().then(r => this.statuses = r);
      group_repository.getHotelGroups(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true}).then(r => this.groups = r);
    },

    methods: {
      save() {
        this.dialog = false;
        this.$emit('save');
      },

      cancel() {
        this.$emit('cancel');
        this.dialog = false;
      }
    }

  }
</script>